const toSafePaginationHref = (value: string): string => {
  const trimmed = value.trim();

  if (!trimmed) {
    return '';
  }

  // Allow only single-slash site-relative URLs (reject protocol-relative `//...`)
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
    return trimmed;
  }

  // Allow only absolute HTTP(s) URLs
  try {
    const parsed = new URL(trimmed);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
      ? parsed.toString()
      : '';
  } catch {
    return '';
  }
};

export default toSafePaginationHref;
